import { render } from "./PublicationsView.vue?vue&type=template&id=a86e150e"
import script from "./PublicationsView.vue?vue&type=script&lang=js"
export * from "./PublicationsView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__